"use client";

import { withFallback } from "../with-fallback";

export const DepositElement = withFallback({
	displayName: "DepositElement",
	type: "deposit-element",
} as const);
